import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.QBooksMatchingPopup.ListOfPurchaseOrders', {
    emptyMessage: 'There are no Purchase Orders to match with',
    title: 'Choose a Purchase order and the respective line:',
});
